export default {
  'settings.title': 'Contract Settings',
  'settings.alert.title': 'Smart Contract Admin (Zero-Secrets)',
  'settings.alert.description': 'The system has been switched to high-security mode: No Private Keys stored. Please connect an Admin personal wallet (MetaMask) to sign transactions.',
  'settings.auth.title': 'Admin Authentication',
  'settings.auth.connected': 'Wallet connected: {address}',
  'settings.auth.changeWallet': 'Change Wallet',
  'settings.auth.logout': 'Disconnect Wallet (Log out)',
  'settings.auth.connectBtn': 'Connect Admin Wallet (MetaMask)',
  'settings.cowe.title': 'COWe Token Configuration',
  'settings.cowe.contract': 'Contract: {address}',
  'settings.cowe.minBalance.title': 'Parameter: Min Balance To Unlock',
  'settings.cowe.minBalance.current': 'Current: {amount} COWe',
  'settings.cowe.minBalance.label': 'Update (COWe)',
  'settings.cowe.minBalance.save': 'Save Min Balance',
  'settings.cowe.setUserLevel.title': 'Set User Level (Manual)',
  'settings.cowe.setUserLevel.wallet': 'Wallet Address',
  'settings.cowe.setUserLevel.level': 'Level (0-2)',
  'settings.cowe.setUserLevel.btn': 'Execute Set Level',
  'settings.mining.title': 'Mining Contract Configuration',
  'settings.mining.contract': 'Contract: {address}',
  'settings.mining.rate.title': 'Mining Rate (COWe / sec)',
  'settings.mining.rate.l1': 'Level 1',
  'settings.mining.rate.l2': 'Level 2',
  'settings.mining.rate.save': 'Save Mining Rate',
  'settings.mining.session.title': 'Mining Session Duration',
  'settings.mining.session.label': 'Unit: Hours',
  'settings.mining.session.save': 'Save Duration',
  'settings.mining.referral.title': 'Referral Mechanism',
  'settings.mining.referral.percent': '% Referral Commission',
  'settings.mining.referral.actBonus': 'Instant Activation Bonus (COWe)',
  'settings.mining.referral.refBonus': 'Instant Referrer Bonus (COWe)',
  'settings.mining.referral.save': 'Save Referral Settings',
  'settings.msg.loading': 'Loading...',
  'settings.msg.initError': 'Error initializing contract:',
  'settings.msg.rpcError': 'Cannot connect to RPC to read Contract data',
  'settings.msg.metamaskError': 'Please install MetaMask or equivalent Web3 wallet',
  'settings.msg.connectSuccess': 'Wallet connected successfully',
  'settings.msg.connectFail': 'Cannot connect wallet',
  'settings.msg.readError': 'Error reading contract parameters:',
  'settings.msg.chainError': 'Error reading on-chain data.',
  'settings.msg.connectFirst': 'Please connect wallet before continuing',
  'settings.msg.txConfirm': 'Sending transaction, please confirm in your wallet...',
  'settings.msg.updateSuccess': 'Update successful!',
  'settings.msg.setLevelSuccess': 'Set Level successful!',
  'settings.msg.rateSuccess': 'Mining Rate updated successfully!',
  'settings.msg.sessionSuccess': 'Mining Session updated successfully!',
  'settings.msg.referralSuccess': 'Referral Mechanism updated successfully!',
  'settings.msg.txPending': 'Transaction pending confirmation...',
  'settings.sync.title': 'Referral Sync Tool',
  'settings.sync.description': 'Scan and sync old referral counts from the legacy system to the Blockchain for migrated wallets.',
  'settings.sync.scanBtn': 'Scan Migrated Wallets',
  'settings.sync.col.wallet': 'Current Wallet',
  'settings.sync.col.oldWallet': 'Old Wallet',
  'settings.sync.col.count': 'Ref Count',
  'settings.sync.col.action': 'Action',
  'settings.sync.action.syncBtn': 'Sync to Chain',
  'settings.sync.msg.noData': 'No wallets found needing synchronization.',
  'settings.sync.msg.success': 'Synced referrals for {address} successfully!',
  'settings.sync.msg.fail': 'Sync failed for {address}: {error}',
  'settings.sync.col.status': 'Status',
  'settings.sync.col.referrerOnChain': 'Referrer (On-chain)',
  'settings.sync.status.success': 'Success',
  'settings.sync.status.self': 'Self-referral',
  'settings.sync.status.notSynced': 'Not synced',
  'settings.sync.status.root': 'Root User',
  'settings.sync.status.none': 'None',
  'settings.sync.modal.title': 'Referral Details - {address}',
  'settings.sync.modal.col.wallet': 'Referral Wallet',
  'settings.sync.modal.col.status': 'On-chain Status',
  'settings.sync.modal.status.synced': 'Synced successfully',
  'settings.sync.modal.close': 'Close',
};
